export default function Logo({ size = "md", variant = "dark" }) {
  const sizes = {
    sm: { icon: 20, text: "text-base" },
    md: { icon: 26, text: "text-xl" },
    lg: { icon: 36, text: "text-3xl" },
    xl: { icon: 56, text: "text-5xl" },
  };
  const s = sizes[size];
  const textColor = variant === "light" ? "text-white" : "text-zinc-950";
  const subColor = variant === "light" ? "text-amber-300" : "text-amber-500";

  return (
    <div className="flex items-center gap-2.5" data-testid="lumioos-logo">
      {/* Glowing orb */}
      <div
        className="relative flex items-center justify-center"
        style={{ width: s.icon, height: s.icon }}
      >
        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-amber-300 via-orange-400 to-pink-500 blur-[6px] opacity-70" />
        <div className="absolute inset-[3px] rounded-full bg-gradient-to-br from-amber-200 via-amber-400 to-orange-500" />
        <div className="absolute inset-[6px] rounded-full bg-white/40 blur-[2px]" />
        <div
          className="absolute rounded-full bg-white/80"
          style={{
            width: s.icon * 0.2, height: s.icon * 0.2,
            top: s.icon * 0.18, left: s.icon * 0.22,
          }}
        />
      </div>
      <span className={`${s.text} ${textColor} font-black tracking-tight font-[Outfit] leading-none whitespace-nowrap`}>
        <span
          className={`${subColor} font-medium italic opacity-80`}
          style={{ fontSize: "0.5em", letterSpacing: "-0.01em", verticalAlign: "0.65em", marginRight: "0.05em" }}
          aria-hidden="true"
        >
          my
        </span>
        Lumi<span className={subColor}>oos</span>
      </span>
    </div>
  );
}
